module.exports = __webpack_public_path__ + "static/img/pic_01@2x.e8811c69.png";